var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('img',{attrs:{"src":require("@/assets/img/error/404.png")}}),_c('p',[_c('span',{staticClass:"txt"},[_vm._v(_vm._s(_vm.time)+"s")]),_vm._v("后返回首页 "),_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.goTo}},[_vm._v("立即返回")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }